import { baseApi } from 'api/baseApi.ts';
import appReducer from 'core/store/reducers/appReducer/AppSlice';
import assetsReducer from 'core/store/reducers/assetsReducer/AssetsSlice';
import canvasReducer from 'core/store/reducers/canvasReducer/CanvasSlice';
import characterStudioReducer from 'core/store/reducers/characterStudioReducer/CharaterStudioSlice';
import homeReducer from 'core/store/reducers/homeReducer/HomeSlice';
import intermediateMediaReducer from 'core/store/reducers/intermediateMediaReducer/IntermediateMediaSlice';
import profileReducer from 'core/store/reducers/profileReducer/ProfileSlice';
import studioReducer from 'core/store/reducers/studioReducer/StudioSlice';

export const commonReducers = {
	app: appReducer,
	profile: profileReducer,
	[baseApi.reducerPath]: baseApi.reducer,
};

export const webReducers = {
	...commonReducers,
	home: homeReducer,
	studio: studioReducer,
	canvas: canvasReducer,
	assets: assetsReducer,
	characterStudio: characterStudioReducer,
	intermediateMedia: intermediateMediaReducer,
};

export const desktopReducers = {
	...commonReducers,
	canvas: canvasReducer,
	assets: assetsReducer,
	characterStudio: characterStudioReducer,
	intermediateMedia: intermediateMediaReducer,
};

export const canvasReducers = {
	...commonReducers,
	canvas: canvasReducer,
	assets: assetsReducer,
};
